import { getAlarmColorState } from "../../tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";

const Item = styled(Paper)(({ theme, bgcolor = 'darkorange' }) => ({
  backgroundColor: bgcolor,
  color: "white",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  // color: theme.palette.text.secondary,
}));

function AckAlarmComp(props) {
  const [ackReason, setAckReason] = useState("");
  const [ackDuration, setAckDuration] = useState("");
  const [validation, setValidation] = useState({
    timeStamp: true,
    reason: true,
  });
  
  const handleAckClose = () => {
    props.handleAckClose();
  }
  const handleAckClick = () => {
    let valid = true;
    let validationObj = {
      timeStamp: true,
      reason: true,
    };
    
    if (!ackDuration || ackDuration === "") {
      validationObj.timeStamp = false;
      valid = false;
    }

    if (!ackReason || ackReason.length < 7) {
      validationObj.reason = false;
      valid = false;
    }
    if (props.DigitalInput && props.DigitalInput.hasOwnProperty("ident")) {
      valid = true;
      validationObj = { ...validationObj, "timeStamp": true, "reason": true };
      //validationObj.reason = true;
    }
    setValidation(validationObj);

    if (valid) {
      props.handleAckTimeSelect(ackDuration, ackReason, props.AlarmId, props.DigitalInput);
    }
  };

  return (    
    <>      
      {props.Open && props.DigitalInput ?
        <DialogContent>
          {(props.AlarmType ? 
            <Item bgcolor={getAlarmColorState({ "AlarmType": props.AlarmType, ...{ "digitalinputb": { ...props.DigitalInput } } })} //{(alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) ? (alarm.digitalinputb.states && alarm.digitalinputb.states.find(item => item.this.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident,"").trim()).value==1 ? '#71816D' : '#DA667B'): 'darkorange' }
              // key={index}
              sx={{
                width: "250px",
                display: "flex",flexDirection:"column",
                alignItems: "center",
                fontSize: "12px",
              }}
            >          
              <div
                className="text-long"
                style={{ maxWidth: "140px" }}
              >
                {props.Display && props.Display != ""
                  ? props.Display
                  : ""}
              </div>
              <div style={{
                display: "flex", flexDirection: "row", justifyContent: "space-between",
                gap: "5px",
                alignItems: "center", padding: "5px 0px 5px 0px"
              }}>        
                
                  <div
                    className="text-long"
                    style={{
                      float: "left",
                      fontSize: "18px",
                      maxWidth: "200px",
                    }}
                  >
                  {props.AlarmType}
                  </div>                                      
              </div>
              <div
                className="text-long"
                style={{
                  float: "left",
                  fontSize: "12px",
                  maxWidth: "200px",
                }}
              >
                {props.Stamp}
              </div>  
            </Item>
            : null)}
        </DialogContent>
        :
        (props.Open) && 
        <DialogContent>
          <RadioGroup
            aria-labelledby="radio-buttons-group-label"
            value={ackDuration}
            onChange={(e) => {
              setAckDuration(e.target.value);
            }}
            name="radio-buttons-group"
          >
            {[2, 6, 12, 24, 48].map((timestamp) => (
              <FormControlLabel
                key={timestamp}
                value={timestamp}
                control={<Radio />}
                label={timestamp + " Hours"}
              />
            ))}
            {!validation.timeStamp && (
              <FormControlLabel
                control={
                  <div
                    style={{
                      color: "#d32f2f",
                      paddingLeft: "14px",
                      fontSize: "12px",
                    }}
                  >
                    {"Please select time for acknowledge"}
                  </div>
                }
              />
            )}
          </RadioGroup>
          <br />
          <TextField
            fullWidth
            required
            error={!validation.reason}
            helperText={
              !validation.reason && "Reason must be at least 7 characters long"
            }
            label="Ack Reason"
            variant="outlined"
            value={ackReason}
            size="small"
            onChange={(e) => {
              setAckReason(e.target.value);
            }}
          />
        </DialogContent>
      }
      <DialogActions sx={{ alignSelf: "center", marginBottom: "10px" }}>
        <Button variant="outlined" onClick={handleAckClose}>
        Close
        </Button>
        <Button variant="outlined" onClick={handleAckClick}>
          Acknowledge
        </Button>
      </DialogActions>
    </>
  );
}

export default AckAlarmComp;
